<template>
  <span :value="value">{{ inner }}</span>
</template>

<script>
function digit(value) {
  return (value || '').padStart(2, '0')
}

export default {
  props: ['value'],
  data() {
    return {
      hours: null,
      minutes: null,
      seconds: null,
    }
  },
  computed: {
    isoValue() {
      return 'PT' + this.hours + 'H' + this.minutes + 'M' + this.seconds + 'S'
    },
    inner() {
      if (this.value) {
        const matched = this.value.match(/PT((\d+)H)?((\d+)M)?((\d+)S)?/)
        if (matched) {
          const hours = digit(matched[2])
          const minutes = digit(matched[4])
          const seconds = digit(matched[6])
          return hours + minutes + seconds
        }
      }
      return null
    },
  },
  methods: {
    emitDuration(value) {
      const matched = value.match(/(\d+h)(\d+m)?(\d+s)?/)
      if (matched) {
        const hours = matched[1]
        const minutes = matched[2] || '0'
        const seconds = matched[3] || '0'

        this.hours = parseInt(hours)
        this.minutes = parseInt(minutes)
        this.seconds = parseInt(seconds)

        this.$emit('span', this.isoValue)
      } else {
        this.$emit('span', null)
      }
    },
  },
}
</script>
